import React, { useEffect } from "react";
import { X, ChevronLeft, ChevronRight } from "lucide-react";
import { API } from "@/lib/api";

export default function PhotoLightbox({ open, onClose, paths = [], index = 0, onIndexChange }) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
      if (e.key === "ArrowLeft") onIndexChange((index - 1 + paths.length) % paths.length);
      if (e.key === "ArrowRight") onIndexChange((index + 1) % paths.length);
    };
    document.body.style.overflow = "hidden";
    window.addEventListener("keydown", onKey);
    return () => {
      document.body.style.overflow = "";
      window.removeEventListener("keydown", onKey);
    };
  }, [open, index, paths.length, onClose, onIndexChange]);

  if (!open || paths.length === 0) return null;

  return (
    <div className="fixed inset-0 z-[100] bg-black/95 grid place-items-center" data-testid="photo-lightbox" onClick={onClose}>
      <button
        onClick={onClose}
        className="absolute top-5 right-5 w-11 h-11 rounded-full bg-white/10 hover:bg-white/20 text-white grid place-items-center"
        aria-label="close"
        data-testid="lightbox-close"
      >
        <X size={20} />
      </button>
      <img
        src={/^https?:\/\//i.test(paths[index]) ? paths[index] : `${API}/files/${paths[index]}`}
        alt=""
        className="max-w-[92vw] max-h-[88vh] object-contain"
        onClick={(e) => e.stopPropagation()}
      />
      {paths.length > 1 && (
        <>
          <button
            onClick={(e) => { e.stopPropagation(); onIndexChange((index - 1 + paths.length) % paths.length); }}
            className="absolute top-1/2 -translate-y-1/2 left-5 w-12 h-12 rounded-full bg-white/10 hover:bg-white/20 text-white grid place-items-center"
            aria-label="prev"
            data-testid="lightbox-prev"
          >
            <ChevronLeft size={22} />
          </button>
          <button
            onClick={(e) => { e.stopPropagation(); onIndexChange((index + 1) % paths.length); }}
            className="absolute top-1/2 -translate-y-1/2 right-5 w-12 h-12 rounded-full bg-white/10 hover:bg-white/20 text-white grid place-items-center"
            aria-label="next"
            data-testid="lightbox-next"
          >
            <ChevronRight size={22} />
          </button>
          <div className="absolute bottom-6 left-1/2 -translate-x-1/2 text-white/80 text-xs">
            {index + 1} / {paths.length}
          </div>
        </>
      )}
    </div>
  );
}
